class OnhowWishlist {
  constructor() {
    this.storageKey = 'onhow-wishlist';
    this.init();
  }

  getWishlist() {
    return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
  }

  setWishlist(items) {
    localStorage.setItem(this.storageKey, JSON.stringify(items));
  }

  init() {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.onhow-wishlist-toggle');
      if (!button) return;

      e.preventDefault();
      e.stopPropagation();

      this.toggleProduct(button);
    });

    this.updateButtons();

    window.addEventListener('onhow:wishlist:updated', () => {
      this.updateButtons();
    });
  }

  toggleProduct(button) {

    /* ✅ ADDED: capture variant + availability + compare price */

    const variantId = button.dataset.variantId || '';
    const variantTitle = button.dataset.variantTitle || '';
    const compareAt = button.dataset.compareAtPrice || '';
    const available = button.dataset.available !== 'false';

    const product = {
      handle: button.dataset.productHandle || button.dataset.productTitle,
      title: button.dataset.productTitle,
      image: button.dataset.productImg,
      price: button.dataset.productPrice,
      url: button.dataset.productUrl,

      /* ✅ NEW FIELDS */
      variant_id: variantId,
      variant_title: variantTitle,
      compare_at_price: compareAt,
      available: available
    };

    let wishlist = this.getWishlist();
    const index = wishlist.findIndex(item => item.handle === product.handle);

    if (index === -1) {
      wishlist.push(product);
      this.setButtonState(button, true);
    } else {
      wishlist.splice(index, 1);
      this.setButtonState(button, false);
    }

    this.setWishlist(wishlist);
    window.dispatchEvent(new CustomEvent('onhow:wishlist:updated', { detail: wishlist }));
    this.updateButtons();
  }

  setButtonState(button, isActive) {
    button.classList.toggle('onhow-in-wishlist', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    button.dataset.added = isActive ? 'true' : 'false';
  }

  updateButtons() {
    const wishlist = this.getWishlist();
    const buttons = document.querySelectorAll('.onhow-wishlist-toggle');

    buttons.forEach(button => {
      const handle = button.dataset.productHandle || button.dataset.productTitle;
      const isActive = wishlist.some(item => item.handle === handle);
      this.setButtonState(button, isActive);
    });

    document.querySelectorAll('.onhow-wishlist-count').forEach(el => {
      el.textContent = wishlist.length;
      el.style.display = wishlist.length ? 'flex' : 'none';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.onhowWishlist = new OnhowWishlist();
});
